var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7,40a2.88,2.88,0,0,1-2.1-.9A2.88,2.88,0,0,1,4,37V11a2.88,2.88,0,0,1,.9-2.1A2.88,2.88,0,0,1,7,8H33a2.88,2.88,0,0,1,2.1.9A2.88,2.88,0,0,1,36,11V21.75l8-8v20.5l-8-8V37a3.08,3.08,0,0,1-3,3Zm0-3H33V11H7Zm0,0v0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.5dec9ea18144afc2d29ada391a2d8677.svg";
export { ForwardRef as ReactComponent };